import React from 'react';
import { BundleDetailTemplate } from './BundleDetailTemplate';

export const BundlePerformance = () => <BundleDetailTemplate slug="performance-development" />;
